<section class="restricted-state card" data-testid="restricted-state" aria-labelledby="restricted-state-heading">

  <span class="restricted-state__badge fal fa-lock" aria-hidden="true"></span>

  <h1 id="restricted-state-heading" class="restricted-state__heading" translate>{{heading}}</h1>

  <p class="restricted-state__message">{{message | translate}}<ng-container *ngIf="peopleDirectoryAvailable"> {{eCommonMessages.FIND_COLLEAGUES_IN_PEOPLE_DIRECTORY | translate}}</ng-container></p>

  <footer class="restricted-state__actions">
    <app-button *ngIf="peopleDirectoryAvailable" [type]="eButtonType.GREEN" (onClick)="goToPeopleDirectory()" data-testid="restricted-state-directory-button">
      <span translate>{{eCommonMessages.BACK_TO_PEOPLE_DIRECTORY}}</span>
    </app-button>

    <app-button [type]="eButtonType.GREEN_INVERTED" (onClick)="goToDashboard()" data-testid="restricted-state-dashboard-button">
      <span translate>{{eCommonMessages.RETURN_TO_DASHBOARD}}</span>
    </app-button>
  </footer>

</section>
